import React from "react";
import { Grid2 as Grid, useTheme } from "@mui/material";

type Props = {
  children: React.ReactNode;
};

export function Footer({ children }: Props) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  return (
    <Grid
      component="footer"
      container
      width="100%"
      px={2}
      py={1}
      spacing={1}
      sx={{ position: "fixed", bottom: 0, left: 0, backgroundColor: isDarkMode ? "#1E1E1E" : "#fff", zIndex: 1000 }}
    >
      {children}
    </Grid>
  );
}
